export default function init() {
  if (window.location.pathname == '/rights') {
    $('#rights-call_consult').on('click', () => {
      window.HUILIU.callFlutter('onIndexService');
      console.log('flutter run onIndexService');
    });
  }
}